import * as React from 'react';
import { Box, Tooltip, Button, MenuItem, TextField, Container, Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Task from '@mui/icons-material/Task';
import ChangeCircle from '@mui/icons-material/ChangeCircle';
import { toast } from 'react-toastify';

import PageDefault from '../../components/PageDefault';
import api from '../../services/api';
import apiDAM from '../../services/apiDAM';

import { Casino, Home, HomeWork, Store } from '@mui/icons-material';
import { getFormatador } from '../../services/helper';
import { hasAnyRole } from '../../services/auth';

export default function ListImoveis() {
  const [imoveis, setImoveis] = React.useState([]);
  const [ruaForm, setRuaForm] = React.useState('todas');
  const [selecionados, setSelecionados] = React.useState([]);
  const [carregando, setCarregando] = React.useState(false);
  const [streets, setStreets] = React.useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [totalElements, setTotalElements] = React.useState(0);

  const canManageImoveis = hasAnyRole(['ADMIN']);

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    titularUnico: false,
    imovelCTN: false,
    isPlanoDiretor: false,
  });

  const navigate = useNavigate();

  const { contribuinteID } = useParams();

  const columns = [
    { field: 'id', headerName: 'ID', width: 50 },
    { field: 'endereco', headerName: 'Endereço', width: 400 },
    { field: 'complemento', headerName: 'Complemento', width: 120 },
    { field: 'contribuinte', headerName: 'Contribuinte', width: 250 },
    { field: 'natureza', headerName: 'Natureza', width: 70, renderCell: (param) => {
      return param.value === 'Construido' ?
      <Tooltip title='Construído'>
        <HomeWork />
      </Tooltip> :
      <Tooltip title='Terreno'>
        <Casino  />
      </Tooltip>
    }},
    { field: 'tipo', headerName: 'Tipo', width: 50, renderCell: (param) => {
      return param.value === 'Comercial' ?
      <Tooltip title='Comercial'>
        <Store  />
      </Tooltip> :
      <Tooltip title='Residencial'>
        <Home  />
      </Tooltip>
    }},
    { field: 'area', headerName: 'Área', width: 70 },
    { field: 'valorM2', headerName: 'Valor M²', width: 85 },
    { field: 'qtdPavimento', headerName: 'Pisos', width: 60 },
    { field: 'titularUnico', headerName: 'Único Titular', width: 90 },
    { field: 'imovelCTN', headerName: 'Imóvel CTN', width: 90 },
    { field: 'isPlanoDiretor', headerName: 'Plano Diretor', width: 90 }
  ];

  React.useEffect(() => {
    setCarregando(true);

    let query = contribuinteID ? `contribuinteId=${contribuinteID}&` : '';
    query = query.concat(ruaForm !== 'todas' ? `rua=${ruaForm}&` : '');

    const formatador = getFormatador();

    api.get(`/contribuinte/imovel?${query}page=${paginationModel.page}&size=${paginationModel.pageSize}`)
      .then(res => {
        const aux = [];
        res.data.content.forEach((item) => {
          const { endereco } = item;
          const numero = endereco.numero === 0 ? 'S/N' : endereco.numero
          aux.push({
            ...item,
            valorM2: formatador.format(item.valorM2),
            endereco: endereco.rua + ', ' + numero + ', ' + endereco.bairro,
            complemento: endereco.complemento,

            imovelCTN: item.imovelCTN ? 'Sim' : '',
            isPlanoDiretor: item.isPlanoDiretor ? 'Sim' : '',
            titularUnico: item.titularUnico ? 'Sim' : ''
          });
        });
        setImoveis(aux);
        setTotalElements(res.data.totalElements);
        setCarregando(false);
      })
      .catch(err => {
        if (err.response) {
          const message = err.response.data.message;
          toast.error(message);
        }
        setImoveis([]);
        setTotalElements(0);
        setCarregando(false);
      });
  }, [contribuinteID, paginationModel.page, paginationModel.pageSize, ruaForm]);

  React.useEffect(() => {

    if (canManageImoveis) {
      api.get('/street')
      .then(res => {
          const aux = [];            
          res.data.content.forEach(({ id, nome, bairro }) => {
              aux.push(nome)
          });
          setStreets(aux);
      })
      .catch(err => {
          if (err.response) {
              const message = err.response.data.message;
              toast.error(message);
          }
          setStreets([])
      });
    } else {
      setStreets([]);
    }
  }, [canManageImoveis]);

  return (    
    <PageDefault carregando={false} title='Imóveis'>
      {canManageImoveis ? (
        <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
          <Grid container spacing={3} mt={2}>
              <Grid item xs={12} >
                  <TextField
                      id="rua"
                      select
                      fullWidth
                      required
                      label="Rua"
                      value={ruaForm}
                      onChange={e => {
                          setRuaForm(e.target.value);
                          setPaginationModel({
                              ...paginationModel,
                              page: 0
                          })
                      }}
                      disabled={carregando}
                  >
                    <MenuItem value='todas'>Todas</MenuItem>
                    {streets.map(s => (
                      <MenuItem value={s} key={s}>
                          {s}
                      </MenuItem>    
                    ))}
                  </TextField>
              </Grid>
          </Grid>
      </Container>
      ) : null}
      <div className='acoes'>
        {canManageImoveis ? (
          <>
            <Tooltip title="Adicionar imóvel">
              <span>
                <Button startIcon={<AddIcon />} disabled={ contribuinteID ? false : true } onClick={() => (
                  navigate(`/contribuintes/${contribuinteID}/novo-imovel`)
                )}>
                  Adicionar
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="Editar imóvel">
              <span>
                <Button startIcon={<EditIcon />} disabled={selecionados.length !== 1} onClick={() => {
                  let contribuinte_id = contribuinteID;

                  if (!contribuinte_id) {
                    imoveis.forEach((item) => {
                      if (selecionados[0] === item.id) {
                        contribuinte_id = item.contribuinte_id;
                      } 
                    })
                  }
                  navigate(`/contribuintes/${contribuinte_id}/editar-imovel/${selecionados[0]}`);
                }}>
                  Editar
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="Remover imóveis">
              <span>
                <Button disabled={true} startIcon={<DeleteIcon />}>Remover</Button>
              </span>
            </Tooltip>
            <Tooltip title="Gerar IPTU para pagamento">
              <span>
                <Button startIcon={<RequestQuoteIcon />} disabled={selecionados.length !== 1} onClick={() => {
                  let contribuinte_id = contribuinteID;

                  if (!contribuinte_id) {
                    imoveis.forEach((item) => {
                      if (selecionados[0] === item.id) {
                        contribuinte_id = item.contribuinte_id;
                      } 
                    })
                  }
                  navigate(`/contribuintes/${contribuinte_id}/imoveis/${selecionados[0]}/calcular-imposto`);
                }}>
                    IPTU
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="Gerar ITBI para pagamento">
              <span>
                <Button startIcon={<RequestQuoteIcon />} disabled={selecionados.length !== 1} onClick={() => {
                  let contribuinte_id = contribuinteID;

                  if (!contribuinte_id) {
                    imoveis.forEach((item) => {
                      if (selecionados[0] === item.id) {
                        contribuinte_id = item.contribuinte_id;
                      } 
                    })
                  }
                  navigate(`/contribuintes/${contribuinte_id}/gerar-cobranca?imovel-id=${selecionados[0]}&tipo=ITIV`);
                }}>
                    ITBI
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="Transferir Imóvel">
              <span>
                <Button startIcon={<ChangeCircle />} disabled={selecionados.length !== 1} onClick={() => {
                  let contribuinte_id = contribuinteID;

                  if (!contribuinte_id) {
                    imoveis.forEach((item) => {
                      if (selecionados[0] === item.id) {
                        contribuinte_id = item.contribuinte_id;
                      } 
                    })
                  }
                  navigate(`/transferir-imovel?contribuinte=${contribuinte_id}&imovel=${selecionados[0]}`);
                }}>
                    Transferir
                </Button>
              </span>
            </Tooltip>
          </>
        ) : null}
        <Tooltip title="Emite Certidão do Imóvel">
          <span>
            <Button startIcon={<Task />} disabled={selecionados.length !== 1} onClick={() => {
              setCarregando(true);
              const imovelId = selecionados[0];
              let contribuinteId = contribuinteID;

              if (!contribuinteId) {
                imoveis.forEach((item) => {
                  if (selecionados[0] === item.id) {
                    contribuinteId = item.contribuinte_id;
                  } 
                })
              }
              
              api.get(`/contribuinte/${contribuinteId}/imovel/${imovelId}/nada-consta`)
              .then(res => {
                setCarregando(false);

                if (!res.data) {
                  toast.error('Imóvel com débito em aberto, é necessário quitar para emitir a certidão!');
                } else {
                  const payload = {
                    contribuinteId,
                    imovelId
                  }
                  
                  apiDAM.post('/certidao-imovel', payload)
                    .then(res => {
                        setCarregando(false);
                        const blob = new Blob([res.data], {
                            type: 'application/pdf'
                        });
                        const url = window.URL.createObjectURL(blob);
                        window.open(url);
                    })
                    .catch(err => {
                        setCarregando(false);
                        const message = err.response.data.message;
                        toast.error(message);
                    })
                }
              })
              .catch(err => {
                setCarregando(false);
                toast.error(err.response.data.message || 'Ocorreu um erro, verifique os dados');
              });
            }}>Certidão</Button>
          </span>
        </Tooltip>
      </div>
      <Box sx={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={imoveis}
          columns={columns}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
          }
          loading={carregando}
          paginationMode='server'
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[paginationModel.pageSize]}
          rowCount={totalElements}
          //keepNonExistentRowsSelected
          checkboxSelection
          // disableRowSelectionOnClick
          onRowSelectionModelChange={(a) => {
            setSelecionados(a)
          }}
          localeText={{
            noRowsLabel: 'Sem imóveis para exibir'
          }}
        />
      </Box>
    </PageDefault>
  );
}